import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  TrainingCategoryApiRequest,
  UpdateTrainingCategoryRequest,
  DeleteTrainingCategoryRequest,
} from '@/data/payload/api/TrainingCategoryRequest'
import { TrainingCategoryPresenter } from '@/app/ui/presenters/TrainingCategoryPresenter'
import { TrainingCategory } from '@/domain/entities/TrainingCategory'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface TrainingCategoryState {
  trainingCategoryData: TrainingCategory
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'categoriesTraining' })
class TrainingCategories extends VuexModule implements TrainingCategoryState {
  public trainingCategoryData = new TrainingCategory(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
      Materialtype: 'training',
    },
    category: 'training',
  }

  @Action
  public async getTrainingCategoryData() {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingCategoryPresenter)
    presenter
      .loadTrainingCategories(this.paginationParam)
      .then((res: TrainingCategory) => {
        this.setLoading(false)
        this.setTrainingCategoryData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postTrainingCategory(params: {
    name: string
    isActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingCategoryPresenter)
    presenter
      .postTrainingCategories(
        new TrainingCategoryApiRequest(
          params.name,
          params.isActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 3000,
        })
        this.getTrainingCategoryData()
      })
      .catch((error) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: 'error',
          type: 'error',
          duration: 3000,
        })
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateTrainingCategory(params: {
    id: number
    name: string
    isActive: boolean
    imageCoverId: number
    imageThumbnailId: number
    imageLogoId: number
    tag: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingCategoryPresenter)
    presenter
      .updateTrainingCategories(
        new UpdateTrainingCategoryRequest(
          params.name,
          params.isActive,
          params.imageCoverId,
          params.imageThumbnailId,
          params.imageLogoId,
          params.tag
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 3000,
        })
        this.getTrainingCategoryData()
      })
      .catch((error) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: 'error',
          type: 'error',
          duration: 3000,
        })
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteTrainingCategory(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingCategoryPresenter)
    presenter
      .deleteTrainingCategories(new DeleteTrainingCategoryRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Category',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getTrainingCategoryData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setTrainingCategoryData(trainingCategory: TrainingCategory) {
    this.trainingCategoryData = trainingCategory
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const TrainingCategoryDataModule = getModule(TrainingCategories)
